import { Component, OnInit, HostListener } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';

@Component({
  selector: 'app-platform',
  templateUrl: './platform.component.html',
  styleUrls: ['./platform.component.scss'],
  standalone: false
})
export class PlatformComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'telematics';

  sections = [
    { id: 'telematics', label: 'Unified Telematics', icon: 'bx-network-chart' },
    { id: 'sdk', label: 'Modular SDK & APIs', icon: 'bx-code-alt' },
    { id: 'miles', label: 'Miles Engine', icon: 'bx-tachometer' },
    { id: 'analytics', label: 'Analytics & Intelligence', icon: 'bx-bar-chart-alt-2' },
    { id: 'security', label: 'Security & Compliance', icon: 'bx-shield-alt-2' },
  ];

  ngOnInit() {}

  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
